import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { SectionTitle, StyledSection } from './Typeahead.styled.js';
function Section({ children, path, query, results, title, isDefault = false }) {
    if (isDefault) {
        return _jsx(StyledSection, { className: "typehead-default-suggestion", children: children(_jsx(_Fragment, {})) });
    }
    if (!results || (path && !results[path])) {
        return _jsx(_Fragment, {});
    }
    const childProps = path && results[path];
    const sectionTitle = childProps === null || childProps === void 0 ? void 0 : childProps.title;
    const childrenToRender = children({
        typeaheadQuery: query,
        ...(childProps ? childProps : {}),
    });
    return (Array.isArray(childrenToRender) &&
        childrenToRender.length > 0 && (_jsxs(StyledSection, { children: [(title || sectionTitle) && _jsx(SectionTitle, { children: title || sectionTitle }), childrenToRender] })));
}
export { Section };
//# sourceMappingURL=Section.js.map